import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getConsultaEmails,
  insertConsultaEmail,
  updateConsultaEmail,
  deleteConsultaEmail,
} from 'services/configuracionPortal'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_CONSULTA_EMAILS() {
  try {
    const consultaEmailsData = yield call(getConsultaEmails)
    if (consultaEmailsData.ok) {
      yield put({
        type: actions.CONSULTA_EMAILS_LOAD_SUCCEEDED,
        payload: consultaEmailsData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar Consulta Emails')
      put({
        type: actions.CONSULTA_EMAILS_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.CONSULTA_EMAILS_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_CONSULTA_EMAIL(action) {
  try {
    const consultaEmailObj = yield call(insertConsultaEmail, action.payload)
    if (consultaEmailObj.ok) {
      putMessage(messageType.SUCCESS, 'Consulta Email creado correctamente')
      yield put({
        type: actions.CONSULTA_EMAIL_INSERT_SUCCEEDED,
        payload: consultaEmailObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Consulta Email')
      yield put({
        type: actions.CONSULTA_EMAIL_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Consulta Email')
    yield all([
      put({
        type: actions.CONSULTA_EMAIL_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_CONSULTA_EMAIL(action) {
  try {
    const consultaEmailObj = yield call(updateConsultaEmail, action.payload)
    if (consultaEmailObj.ok) {
      putMessage(messageType.SUCCESS, 'Consulta Email modificado correctamente')
      yield put({
        type: actions.CONSULTA_EMAIL_UPDATE_SUCCEEDED,
        payload: consultaEmailObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Consulta Email')
      yield put({
        type: actions.CONSULTA_EMAIL_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Consulta Email')
    yield all([
      put({
        type: actions.CONSULTA_EMAIL_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_CONSULTA_EMAIL(action) {
  try {
    const consultaEmailResult = yield call(deleteConsultaEmail, action.payload)
    if (consultaEmailResult.ok) {
      putMessage(messageType.SUCCESS, 'Consulta Email eliminado correctamente')
      yield put({
        type: actions.CONSULTA_EMAIL_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Consulta Email')
      yield put({
        type: actions.CONSULTA_EMAIL_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Consulta Email')
    yield all([
      put({
        type: actions.CONSULTA_EMAIL_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.CONSULTA_EMAILS_LOAD_REQUESTED, GET_CONSULTA_EMAILS),
    takeEvery(actions.CONSULTA_EMAIL_INSERT_REQUESTED, INSERT_CONSULTA_EMAIL),
    takeEvery(actions.CONSULTA_EMAIL_UPDATE_REQUESTED, UPDATE_CONSULTA_EMAIL),
    takeEvery(actions.CONSULTA_EMAIL_DELETE_REQUESTED, DELETE_CONSULTA_EMAIL),
  ])
}
